// extracted by css-extract-rspack-plugin
export default {"CommentBox":"Shared-module__CommentBox__wPxKr"};